import { render } from "./shortcut-item.vue?vue&type=template&id=3c8f1c16&scoped=true"
import script from "./shortcut-item.vue?vue&type=script&lang=js"
export * from "./shortcut-item.vue?vue&type=script&lang=js"

import "./shortcut-item.vue?vue&type=style&index=0&id=3c8f1c16&lang=scss&scoped=true"

import exportComponent from "/home/workspace/cf-dkf-web-micro-base-interior-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8f1c16"]])

export default __exports__